'use strict';

/* jshint ignore:start */
/**
 * This code was generated by
 * \ / _    _  _|   _  _
 *  | (_)\/(_)(_|\/| |(/_  v1.0.0
 *       /       /
 */
/* jshint ignore:end */

var Q = require('q');  /* jshint ignore:line */
var _ = require('lodash');  /* jshint ignore:line */
var util = require('util');  /* jshint ignore:line */
var Page = require('../../../../base/Page');  /* jshint ignore:line */
var deserialize = require(
    '../../../../base/deserialize');  /* jshint ignore:line */
var values = require('../../../../base/values');  /* jshint ignore:line */

var OutgoingCallerIdList;
var OutgoingCallerIdPage;
var OutgoingCallerIdInstance;
var OutgoingCallerIdContext;

/* jshint ignore:start */
/**
 * Initialize the OutgoingCallerIdList
 *
 * @constructor Twilio.Api.V2010.AccountContext.OutgoingCallerIdList
 *
 * @param {Twilio.Api.V2010} version - Version of the resource
 * @param {string} accountSid - The SID of the Account that created the resource
 */
/* jshint ignore:end */
OutgoingCallerIdList = function OutgoingCallerIdList(version, accountSid) {
  /* jshint ignore:start */
  /**
   * @function outgoingCallerIds
   * @memberof Twilio.Api.V2010.AccountContext#
   *
   * @param {string} sid - sid of instance
   *
   * @returns {Twilio.Api.V2010.AccountContext.OutgoingCallerIdContext}
   */
  /* jshint ignore:end */
  function OutgoingCallerIdListInstance(sid) {
    return OutgoingCallerIdListInstance.get(sid);
  }

  OutgoingCallerIdListInstance._version = version;
  // Path Solution
  OutgoingCallerIdListInstance._solution = {accountSid: accountSid};
  OutgoingCallerIdListInstance._uri = `/Accounts/${accountSid}/OutgoingCallerIds.json`;
  /* jshint ignore:start */
  /**
   * Streams OutgoingCallerIdInstance records from the API.
   *
   * This operation lazily loads records as efficiently as possible until the limit
   * is reached.
   *
   * The results are passed into the callback function, so this operation is memory
   * efficient.
   *
   * If a function is passed as the first argument, it will be used as the callback
   * function.
   *
   * @function each
   * @memberof Twilio.Api.V2010.AccountContext.OutgoingCallerIdList#
   *
   * @param {object} [opts] - Options for request
   * @param {string} [opts.phoneNumber] -
   *          The phone number of the OutgoingCallerId resources to read
   * @param {string} [opts.friendlyName] -
   *          The string that identifies the OutgoingCallerId resources to read
   * @param {number} [opts.limit] -
   *         Upper limit for the number of records to return.
   *         each() guarantees never to return more than limit.
   *         Default is no limit
   * @param {number} [opts.pageSize] -
   *         Number of records to fetch per request,
   *         when not set will use the default value of 50 records.
   *         If no pageSize is defined but a limit is defined,
   *         each() will attempt to read the limit with the most efficient
   *         page size, i.e. min(limit, 1000)
   * @param {Function} [opts.callback] -
   *         Function to process each record. If this and a positional
   *         callback are passed, this one will be used
   * @param {Function} [opts.done] -
   *          Function to be called upon completion of streaming
   * @param {Function} [callback] - Function to process each record
   */
  /* jshint ignore:end */
  OutgoingCallerIdListInstance.each = function each(opts, callback) {
    if (_.isFunction(opts)) {
      callback = opts;
      opts = {};
    }
    opts = opts || {};
    if (opts.callback) {
      callback = opts.callback;
    }
    if (_.isUndefined(callback)) {
      throw new Error('Callback function must be provided');
    }

    var done = false;
    var currentPage = 1;
    var currentResource = 0;
    var limits = this._version.readLimits({
      limit: opts.limit,
      pageSize: opts.pageSize
    });

    function onComplete(error) {
      done = true;
      if (_.isFunction(opts.done)) {
        opts.done(error);
      }
    }

    function fetchNextPage(fn) {
      var promise = fn();
      if (_.isUndefined(promise)) {
        onComplete();
        return;
      }

      promise.then(function(page) {
        _.each(page.instances, function(instance) {
          if (done || (!_.isUndefined(opts.limit) && currentResource >= opts.limit)) {
            done = true;
            return false;
          }

          currentResource++;
          callback(instance, onComplete);
        });

        if (!done) {
          currentPage++;
          fetchNextPage(_.bind(page.nextPage, page));
        } else {
          onComplete();
        }
      });

      promise.catch(onComplete);
    }

    fetchNextPage(_.bind(this.page, this, _.merge(opts, limits)));
  };

  /* jshint ignore:start */
  /**
   * Lists OutgoingCallerIdInstance records from the API as a list.
   *
   * If a function is passed as the first argument, it will be used as the callback
   * function.
   *
   * @function list
   * @memberof Twilio.Api.V2010.AccountContext.OutgoingCallerIdList#
   *
   * @param {object} [opts] - Options for request
   * @param {string} [opts.phoneNumber] -
   *          The phone number of the OutgoingCallerId resources to read
   * @param {string} [opts.friendlyName] -
   *          The string that identifies the OutgoingCallerId resources to read
   * @param {number} [opts.limit] -
   *         Upper limit for the number of records to return.
   *         list() guarantees never to return more than limit.
   *         Default is no limit
   * @param {number} [opts.pageSize] -
   *         Number of records to fetch per request,
   *         when not set will use the default value of 50 records.
   *         If no page_size is defined but a limit is defined,
   *         list() will attempt to read the limit with the most
   *         efficient page size, i.e. min(limit, 1000)
   * @param {function} [callback] - Callback to handle list of records
   *
   * @returns {Promise} Resolves to a list of records
   */
  /* jshint ignore:end */
  OutgoingCallerIdListInstance.list = function list(opts, callback) {
    if (_.isFunction(opts)) {
      callback = opts;
      opts = {};
    }
    opts = opts || {};
    var deferred = Q.defer();
    var allResources = [];
    opts.callback = function(resource, done) {
      allResources.push(resource);

      if (!_.isUndefined(opts.limit) && allResources.length === opts.limit) {
        done();
      }
    };

    opts.done = function(error) {
      if (_.isUndefined(error)) {
        deferred.resolve(allResources);
      } else {
        deferred.reject(error);
      }
    };

    if (_.isFunction(callback)) {
      deferred.promise.nodeify(callback);
    }

    this.each(opts);
    return deferred.promise;
  };

  /* jshint ignore:start */
  /**
   * Retrieve a single page of OutgoingCallerIdInstance records from the API.
   *
   * The request is executed immediately.
   *
   * If a function is passed as the first argument, it will be used as the callback
   * function.
   *
   * @function page
   * @memberof Twilio.Api.V2010.AccountContext.OutgoingCallerIdList#
   *
   * @param {object} [opts] - Options for request
   * @param {string} [opts.phoneNumber] -
   *          The phone number of the OutgoingCallerId resources to read
   * @param {string} [opts.friendlyName] -
   *          The string that identifies the OutgoingCallerId resources to read
   * @param {string} [opts.pageToken] - PageToken provided by the API
   * @param {number} [opts.pageNumber] -
   *          Page Number, this value is simply for client state
   * @param {number} [opts.pageSize] - Number of records to return, defaults to 50
   * @param {function} [callback] - Callback to handle list of records
   *
   * @returns {Promise} Resolves to a list of records
   */
  /* jshint ignore:end */
  OutgoingCallerIdListInstance.page = function page(opts, callback) {
    if (_.isFunction(opts)) {
      callback = opts;
      opts = {};
    }
    opts = opts || {};

    var deferred = Q.defer();
    var data = values.of({
      'PhoneNumber': _.get(opts, 'phoneNumber'),
      'FriendlyName': _.get(opts, 'friendlyName'),
      'PageToken': opts.pageToken,
      'Page': opts.pageNumber,
      'PageSize': opts.pageSize
    });

    var promise = this._version.page({uri: this._uri, method: 'GET', params: data});

    promise = promise.then(function(payload) {
      deferred.resolve(new OutgoingCallerIdPage(this._version, payload, this._solution));
    }.bind(this));

    promise.catch(function(error) {
      deferred.reject(error);
    });

    if (_.isFunction(callback)) {
      deferred.promise.nodeify(callback);
    }

    return deferred.promise;
  };

  /* jshint ignore:start */
  /**
   * Retrieve a single target page of OutgoingCallerIdInstance records from the API.
   *
   * The request is executed immediately.
   *
   * If a function is passed as the first argument, it will be used as the callback
   * function.
   *
   * @function getPage
   * @memberof Twilio.Api.V2010.AccountContext.OutgoingCallerIdList#
   *
   * @param {string} [targetUrl] - API-generated URL for the requested results page
   * @param {function} [callback] - Callback to handle list of records
   *
   * @returns {Promise} Resolves to a list of records
   */
  /* jshint ignore:end */
  OutgoingCallerIdListInstance.getPage = function getPage(targetUrl, callback) {
    var deferred = Q.defer();

    var promise = this._version._domain.twilio.request({method: 'GET', uri: targetUrl});

    promise = promise.then(function(payload) {
      deferred.resolve(new OutgoingCallerIdPage(this._version, payload, this._solution));
    }.bind(this));

    promise.catch(function(error) {
      deferred.reject(error);
    });

    if (_.isFunction(callback)) {
      deferred.promise.nodeify(callback);
    }

    return deferred.promise;
  };

  /* jshint ignore:start */
  /**
   * Constructs a outgoing_caller_id
   *
   * @function get
   * @memberof Twilio.Api.V2010.AccountContext.OutgoingCallerIdList#
   *
   * @param {string} sid - The unique string that identifies the resource
   *
   * @returns {Twilio.Api.V2010.AccountContext.OutgoingCallerIdContext}
   */
  /* jshint ignore:end */
  OutgoingCallerIdListInstance.get = function get(sid) {
    return new OutgoingCallerIdContext(this._version, this._solution.accountSid, sid);
  };

  /* jshint ignore:start */
  /**
   * Provide a user-friendly representation
   *
   * @function toJSON
   * @memberof Twilio.Api.V2010.AccountContext.OutgoingCallerIdList#
   *
   * @returns Object
   */
  /* jshint ignore:end */
  OutgoingCallerIdListInstance.toJSON = function toJSON() {
    return this._solution;
  };

  OutgoingCallerIdListInstance[util.inspect.custom] = function inspect(depth,
      options) {
    return util.inspect(this.toJSON(), options);
  };

  return OutgoingCallerIdListInstance;
};


/* jshint ignore:start */
/**
 * Initialize the OutgoingCallerIdPage
 *
 * @constructor Twilio.Api.V2010.AccountContext.OutgoingCallerIdPage
 *
 * @param {V2010} version - Version of the resource
 * @param {Response<string>} response - Response from the API
 * @param {OutgoingCallerIdSolution} solution - Path solution
 *
 * @returns OutgoingCallerIdPage
 */
/* jshint ignore:end */
OutgoingCallerIdPage = function OutgoingCallerIdPage(version, response,
                                                      solution) {
  // Path Solution
  this._solution = solution;

  Page.prototype.constructor.call(this, version, response, this._solution);
};

_.extend(OutgoingCallerIdPage.prototype, Page.prototype);
OutgoingCallerIdPage.prototype.constructor = OutgoingCallerIdPage;

/* jshint ignore:start */
/**
 * Build an instance of OutgoingCallerIdInstance
 *
 * @function getInstance
 * @memberof Twilio.Api.V2010.AccountContext.OutgoingCallerIdPage#
 *
 * @param {OutgoingCallerIdPayload} payload - Payload response from the API
 *
 * @returns OutgoingCallerIdInstance
 */
/* jshint ignore:end */
OutgoingCallerIdPage.prototype.getInstance = function getInstance(payload) {
  return new OutgoingCallerIdInstance(this._version, payload, this._solution.accountSid);
};

/* jshint ignore:start */
/**
 * Provide a user-friendly representation
 *
 * @function toJSON
 * @memberof Twilio.Api.V2010.AccountContext.OutgoingCallerIdPage#
 *
 * @returns Object
 */
/* jshint ignore:end */
OutgoingCallerIdPage.prototype.toJSON = function toJSON() {
  let clone = {};
  _.forOwn(this, function(value, key) {
    if (!_.startsWith(key, '_') && ! _.isFunction(value)) {
      clone[key] = value;
    }
  });
  return clone;
};

OutgoingCallerIdPage.prototype[util.inspect.custom] = function inspect(depth,
    options) {
  return util.inspect(this.toJSON(), options);
};


/* jshint ignore:start */
/**
 * Initialize the OutgoingCallerIdContext
 *
 * @constructor Twilio.Api.V2010.AccountContext.OutgoingCallerIdInstance
 *
 * @property {string} sid - The unique string that identifies the resource
 * @property {Date} dateCreated -
 *          The RFC 2822 date and time in GMT that the resource was created
 * @property {Date} dateUpdated -
 *          The RFC 2822 date and time in GMT that the resource was last updated
 * @property {string} friendlyName -
 *          The string that you assigned to describe the resource
 * @property {string} accountSid - The SID of the Account that created the resource
 * @property {string} phoneNumber - The phone number in E.164 format
 * @property {string} uri -
 *          The URI of the resource, relative to `https://api.twilio.com`
 *
 * @param {V2010} version - Version of the resource
 * @param {OutgoingCallerIdPayload} payload - The instance payload
 * @param {sid} accountSid - The SID of the Account that created the resource
 * @param {sid} sid - The unique string that identifies the resource
 */
/* jshint ignore:end */
OutgoingCallerIdInstance = function OutgoingCallerIdInstance(version, payload,
    accountSid, sid) {
  this._version = version;

  // Marshaled Properties
  this.sid = payload.sid; // jshint ignore:line
  this.dateCreated = deserialize.rfc2822DateTime(payload.date_created); // jshint ignore:line
  this.dateUpdated = deserialize.rfc2822DateTime(payload.date_updated); // jshint ignore:line
  this.friendlyName = payload.friendly_name; // jshint ignore:line
  this.accountSid = payload.account_sid; // jshint ignore:line
  this.phoneNumber = payload.phone_number; // jshint ignore:line
  this.uri = payload.uri; // jshint ignore:line

  // Context
  this._context = undefined;
  this._solution = {accountSid: accountSid, sid: sid || this.sid, };
};

Object.defineProperty(OutgoingCallerIdInstance.prototype,
  '_proxy', {
    get: function() {
      if (!this._context) {
        this._context = new OutgoingCallerIdContext(
          this._version,
          this._solution.accountSid,
          this._solution.sid
        );
      }

      return this._context;
    }
});

/* jshint ignore:start */
/**
 * fetch a OutgoingCallerIdInstance
 *
 * @function fetch
 * @memberof Twilio.Api.V2010.AccountContext.OutgoingCallerIdInstance#
 *
 * @param {function} [callback] - Callback to handle processed record
 *
 * @returns {Promise} Resolves to processed OutgoingCallerIdInstance
 */
/* jshint ignore:end */
OutgoingCallerIdInstance.prototype.fetch = function fetch(callback) {
  return this._proxy.fetch(callback);
};

/* jshint ignore:start */
/**
 * update a OutgoingCallerIdInstance
 *
 * @function update
 * @memberof Twilio.Api.V2010.AccountContext.OutgoingCallerIdInstance#
 *
 * @param {object} [opts] - Options for request
 * @param {string} [opts.friendlyName] - A string to describe the resource
 * @param {function} [callback] - Callback to handle processed record
 *
 * @returns {Promise} Resolves to processed OutgoingCallerIdInstance
 */
/* jshint ignore:end */
OutgoingCallerIdInstance.prototype.update = function update(opts, callback) {
  return this._proxy.update(opts, callback);
};

/* jshint ignore:start */
/**
 * remove a OutgoingCallerIdInstance
 *
 * @function remove
 * @memberof Twilio.Api.V2010.AccountContext.OutgoingCallerIdInstance#
 *
 * @param {function} [callback] - Callback to handle processed record
 *
 * @returns {Promise} Resolves to processed OutgoingCallerIdInstance
 */
/* jshint ignore:end */
OutgoingCallerIdInstance.prototype.remove = function remove(callback) {
  return this._proxy.remove(callback);
};

/* jshint ignore:start */
/**
 * Provide a user-friendly representation
 *
 * @function toJSON
 * @memberof Twilio.Api.V2010.AccountContext.OutgoingCallerIdInstance#
 *
 * @returns Object
 */
/* jshint ignore:end */
OutgoingCallerIdInstance.prototype.toJSON = function toJSON() {
  let clone = {};
  _.forOwn(this, function(value, key) {
    if (!_.startsWith(key, '_') && ! _.isFunction(value)) {
      clone[key] = value;
    }
  });
  return clone;
};

OutgoingCallerIdInstance.prototype[util.inspect.custom] = function
    inspect(depth, options) {
  return util.inspect(this.toJSON(), options);
};


/* jshint ignore:start */
/**
 * Initialize the OutgoingCallerIdContext
 *
 * @constructor Twilio.Api.V2010.AccountContext.OutgoingCallerIdContext
 *
 * @param {V2010} version - Version of the resource
 * @param {sid} accountSid -
 *          The SID of the Account that created the resource to fetch
 * @param {sid} sid - The unique string that identifies the resource
 */
/* jshint ignore:end */
OutgoingCallerIdContext = function OutgoingCallerIdContext(version, accountSid,
                                                            sid) {
  this._version = version;

  // Path Solution
  this._solution = {accountSid: accountSid, sid: sid, };
  this._uri = `/Accounts/${accountSid}/OutgoingCallerIds/${sid}.json`;
};

/* jshint ignore:start */
/**
 * fetch a OutgoingCallerIdInstance
 *
 * @function fetch
 * @memberof Twilio.Api.V2010.AccountContext.OutgoingCallerIdContext#
 *
 * @param {function} [callback] - Callback to handle processed record
 *
 * @returns {Promise} Resolves to processed OutgoingCallerIdInstance
 */
/* jshint ignore:end */
OutgoingCallerIdContext.prototype.fetch = function fetch(callback) {
  var deferred = Q.defer();
  var promise = this._version.fetch({uri: this._uri, method: 'GET'});

  promise = promise.then(function(payload) {
    deferred.resolve(new OutgoingCallerIdInstance(
      this._version,
      payload,
      this._solution.accountSid,
      this._solution.sid
    ));
  }.bind(this));

  promise.catch(function(error) {
    deferred.reject(error);
  });

  if (_.isFunction(callback)) {
    deferred.promise.nodeify(callback);
  }

  return deferred.promise;
};

/* jshint ignore:start */
/**
 * update a OutgoingCallerIdInstance
 *
 * @function update
 * @memberof Twilio.Api.V2010.AccountContext.OutgoingCallerIdContext#
 *
 * @param {object} [opts] - Options for request
 * @param {string} [opts.friendlyName] - A string to describe the resource
 * @param {function} [callback] - Callback to handle processed record
 *
 * @returns {Promise} Resolves to processed OutgoingCallerIdInstance
 */
/* jshint ignore:end */
OutgoingCallerIdContext.prototype.update = function update(opts, callback) {
  if (_.isFunction(opts)) {
    callback = opts;
    opts = {};
  }
  opts = opts || {};

  var deferred = Q.defer();
  var data = values.of({'FriendlyName': _.get(opts, 'friendlyName')});

  var promise = this._version.update({uri: this._uri, method: 'POST', data: data});

  promise = promise.then(function(payload) {
    deferred.resolve(new OutgoingCallerIdInstance(
      this._version,
      payload,
      this._solution.accountSid,
      this._solution.sid
    ));
  }.bind(this));

  promise.catch(function(error) {
    deferred.reject(error);
  });

  if (_.isFunction(callback)) {
    deferred.promise.nodeify(callback);
  }

  return deferred.promise;
};

/* jshint ignore:start */
/**
 * remove a OutgoingCallerIdInstance
 *
 * @function remove
 * @memberof Twilio.Api.V2010.AccountContext.OutgoingCallerIdContext#
 *
 * @param {function} [callback] - Callback to handle processed record
 *
 * @returns {Promise} Resolves to processed OutgoingCallerIdInstance
 */
/* jshint ignore:end */
OutgoingCallerIdContext.prototype.remove = function remove(callback) {
  var deferred = Q.defer();
  var promise = this._version.remove({uri: this._uri, method: 'DELETE'});

  promise = promise.then(function(payload) {
    deferred.resolve(payload);
  }.bind(this));

  promise.catch(function(error) {
    deferred.reject(error);
  });

  if (_.isFunction(callback)) {
    deferred.promise.nodeify(callback);
  }

  return deferred.promise;
};

/* jshint ignore:start */
/**
 * Provide a user-friendly representation
 *
 * @function toJSON
 * @memberof Twilio.Api.V2010.AccountContext.OutgoingCallerIdContext#
 *
 * @returns Object
 */
/* jshint ignore:end */
OutgoingCallerIdContext.prototype.toJSON = function toJSON() {
  return this._solution;
};

OutgoingCallerIdContext.prototype[util.inspect.custom] = function inspect(depth,
    options) {
  return util.inspect(this.toJSON(), options);
};

module.exports = {
  OutgoingCallerIdList: OutgoingCallerIdList,
  OutgoingCallerIdPage: OutgoingCallerIdPage,
  OutgoingCallerIdInstance: OutgoingCallerIdInstance,
  OutgoingCallerIdContext: OutgoingCallerIdContext
};
